import { render, staticRenderFns } from "./block2.vue?vue&type=template&id=2ee608ac&scoped=true&"
import script from "./block2.vue?vue&type=script&lang=js&"
export * from "./block2.vue?vue&type=script&lang=js&"
import style0 from "./block2.vue?vue&type=style&index=0&id=2ee608ac&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee608ac",
  null
  
)

export default component.exports